import Vue from "vue";

import _Home from "./Home.vue";
export const Home = Vue.component("home", _Home);

import _Refresher from "./Refresher.vue";
export const Refresher = Vue.component("refresher", _Refresher);
